module.exports = __webpack_public_path__ + "static/product-page-1-3b21f8c0116188143ffd5de69b8d2185.png";